<mat-toolbar class="navbar navbar-expand-lg toolbar">
    <a class="navbar-brand">
        <img src="assets/images/logo.svg" alt="Logo"> <!-- Coloca aquí la ruta a tu logo -->
    </a>
    <a mat-button href="admin-cammelers">Gestión Cammelers</a>
    <a mat-button>Contact</a>
</mat-toolbar>